module.exports = __webpack_public_path__ + "images/electricfreeway8fe98c34e8877d079ae73b1c011f1fe2.png";